import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import DisactiveIcon from '@/assets/icons/disactive-icon.svg?react';
import PropTypes from 'prop-types';

const IsActiveField = ({ record }) => (record.isActive ? <ActiveIcon /> : <DisactiveIcon />);

IsActiveField.propTypes = {
    record: PropTypes.shape({
        isActive: PropTypes.bool,
    }),
};

export default IsActiveField;
